import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { normalizeImageUrl } from '../../utils/image-url.utils';

export interface CallToActionCardProps {
    title: string;
    subtitle: string;
    buttonText: string;
    buttonLink: string;
    imageUrl: string;
}

export const CallToActionCard = ({
    title,
    subtitle,
    buttonText,
    buttonLink,
    imageUrl,
}: CallToActionCardProps): JSX.Element => {
    const history = useHistory();

    return (
        <Card variant="outlined" sx={{ bgcolor: 'background.paper' }}>
            <CardContent
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 3,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Box sx={{ flex: 1 }}>
                    <Typography variant="h5" component="h2" gutterBottom>
                        {title}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'text.secondary',
                            marginBottom: '16px',
                        }}
                    >
                        {subtitle}
                    </Typography>
                    <Button
                        variant="contained"
                        size="medium"
                        onClick={() => history.push(buttonLink)}
                    >
                        {buttonText}
                    </Button>
                </Box>
                <Box
                    component="img"
                    src={normalizeImageUrl(imageUrl)}
                    alt="Call to action"
                    sx={{ display: 'block', width: '100%', maxWidth: 300 }}
                />
            </CardContent>
        </Card>
    );
};
